import PropTypes from 'prop-types';
import React from 'react';
import TString from './TString';

const TSpan = (props) =>
	<TString {...props} tagName="span" />;

export default TSpan;
